import { useMyAuth0Id } from "@components/ReportReview/hooks/useMyAuth0Id";
import { useReportReviewers } from "@components/ReportReview/hooks/useReportReviewers";
import { getFinalApproverWaitReason, resolveReviewSetting } from "@components/ReportReview/reviewApproval";
import { useReport } from "@providers/ReportProvider";

export const useFinalApproverWaitReason = (): string | undefined => {
  const { report } = useReport();
  const { reviewers } = useReportReviewers();
  const myId = useMyAuth0Id();

  return getFinalApproverWaitReason({
    waitsForReviewers: resolveReviewSetting(
      report.reportTemplate?.finalApproverWaitsForReviewers,
      report.organization?.finalApproverWaitsForReviewers,
    ),
    myId,
    reviewers,
  });
};
